// const url = `https://api.cloudinary.com/v1_1/djxrhf2jg/image/upload`
// //${process.env.CLOUDINARY_CLOUD_NAME}
// const uploadImage = async(image)=>{
//     const formData = new FormData()
//     formData.append("file", image)
//     formData.append("upload_preset", "sonajhuri_product")
//     const datResponse = await fetch(url,{
//         method : "post",
//         body : formData
//     })
//     return datResponse.json()
// }
// export default uploadImage

const url = `https://api.cloudinary.com/v1_1/djxrhf2jg/image/upload`
//${process.env.CLOUDINARY_CLOUD_NAME}
const uploadImage = async(image)=>{
    const formData = new FormData();
    formData.append("file", image);
    formData.append("upload_preset", "sonajhuri_product");
    //formData.append("transformation", "q_auto,f_auto,w_1200,c_limit");
    const datResponse = await fetch(url,{
        method : "post",
        body : formData
    })
    return datResponse.json()
}
export default uploadImage
